angular.module('bmsApp.crm.customer').factory('CustomerReminderSvc', function (CRUDSvc) {

	return {
		scheduleIndex: function () {
			return CRUDSvc.get('api/customer/reminders/schedule/index');
		},
		scheduleSaveAll: function (params) {
			return CRUDSvc.post('api/customer/reminders/schedule/saveAll', params);
		}
	};

});
